<template>
	<construction-page v-bind="pageConfig" />
</template>

<script>
import constructionPage from "@/components/constructionPage.vue";
import constructionPagesConfig from "@/config/constructionPages.js";

export default {
	name: "ConstructionPageView",
	components: { constructionPage },
	computed: {
		pageConfig() {
			const name = this.$route.name;
			return constructionPagesConfig[name] || {};
		},
	},
};
</script>
